import { setIDPhoto, setSignUpStep } from '../../../../store/signUp/slice';
import { useDispatch, useSelector } from '../../../../store/store';
import { selectIDPhoto } from '../../../../store/signUp/selectors';
import MotionWrapper from '../../../../containers/MotionWrapper';
import { useWebcam } from '../../../../hooks/useWebcam';
import DropBox from '../../../../containers/DropBox';
import Button from '../../../../components/Button';
import styles from './style.module.scss';
import Webcam from 'react-webcam';
import { useState } from 'react';
import { CameraIcon, PaperclipIcon } from '../../../../assets/icons/common';
// import UploadBox from '../../../../containers/UploadBox';

const sample = require('../../../../assets/images/kyc_id.png');

function UploadPersonalID() {
    const IDPhoto = useSelector(selectIDPhoto);
    const [mode, setMode] = useState<'Camera' | 'Upload'>('Camera');
    const [file, setFile] = useState<File | null>(null);
    const dispatch = useDispatch();

    const {
        imgSrc,
        webcamRef,
        setImgSrc,
        captureImage,
    } = useWebcam();

    const takePhoto = () => {
        if (imgSrc) {
            setImgSrc(null)
        } else {
            captureImage();
        }
    };

    const changeMode = () => {
        setImgSrc(null);
        setFile(null);
        setMode(prev => prev === 'Camera' ? 'Upload' : 'Camera');
    };

    const next = () => {
        if (mode === 'Upload' && file) {
            const objectURL = URL.createObjectURL(file);
            dispatch(setIDPhoto(objectURL));
        } else {
            dispatch(setIDPhoto(imgSrc));
        }

        dispatch(setSignUpStep('KYC'));
    };

    return (
        <MotionWrapper className={styles.wrapper}>
            <div className={styles.box}>
                {mode === 'Camera' && <>
                    <span className={styles.box_title}>
                        Please take a live photo of your ID or upload the relevant document
                    </span>
                    <div className={styles.sample}>
                        <img src={sample} alt="sample" />
                    </div>
                    <div className={styles.camera}>
                        {!imgSrc ? <Webcam
                            audio={false}
                            ref={webcamRef}
                            disablePictureInPicture
                            screenshotFormat="image/png"
                        /> : <img src={imgSrc} />}
                    </div>
                    <div className={styles.actions}>
                        <Button
                            onClick={takePhoto}
                            type='Outline-Primary'
                            icon={<CameraIcon />}
                            className={styles.actions_btn}
                            text={imgSrc ? 'Retake photo' : 'Take photo'}
                        />
                    </div>
                </>}
                {mode === 'Upload' && <>
                    <span className={styles.box_title}>
                        Please upload your identity document
                    </span>
                    {/* <UploadBox
                aspect={1}
                onSave={onSave}
                fileTypes={fileTypes}
                isSaveBtnLoading={isLoading}
            /> */}
                    <DropBox
                        file={file}
                        uploading={false}
                        setFile={setFile}
                        fileTypes={{ 'image': ['.PNG', '.JPEG', '.JPG'], }}
                        description='PNG, JPEG or JPG , Maximum upload file size: 12MB'
                    />
                </>}
            </div>
            <div className={styles.change_option}>
                <span className={styles.change_option_text}>
                    {mode === 'Camera' ? ' Also you can upload the relevent documents' : 'Also you can take a live photo of your ID'}
                </span>
                <div
                    className={styles.change_option_link}
                    onClick={changeMode}
                >
                    {mode === 'Camera' ? <PaperclipIcon /> : <CameraIcon />}
                    <span>
                        {mode === 'Camera' ? ' Upload document' : 'Take photo'}
                    </span>
                </div>
            </div>
            <div className={styles.actions}>
                <Button
                    size='sm'
                    text='Back'
                    type='Outline-Dark'
                    className={styles.actions_btn}
                    onClick={() => dispatch(setSignUpStep('uploadProfilePhoto'))}
                />
                <Button
                    size='sm'
                    type='Primary'
                    text='Continue'
                    onClick={next}
                    disabled={!imgSrc && !file}
                    className={styles.actions_btn}
                />
            </div>
        </MotionWrapper>
    );
};

export default UploadPersonalID;
